import React, { useEffect, useState } from "react";

const Price = ({data}) => {
  const [totalPrice, setTotalPrice] = useState(0);
  const sumPrice = (data) => {
    // supplyPrice: 120000,
    //   surtax: 12000
    data.orderData.forEach((e) => {
      e.supplyPrice && 
      setTotalPrice((totalPrice) => totalPrice + e.supplyPrice + e.surtax);
    })
  }

  const priceComma = (price) => {
    return price.toLocaleString('ko-KR', {maximumFractionDigits: 0})
  }

  const priceToKorean = (price) => {
    const koreanNumber = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
    const tenUnit = ['', '십', '백', '천'];
    const tenThousandUnit = ['조', '억', '만', ''];
    const unit = 10000;

    let answer = '';

    while (price > 0) {
      const mod = price % unit;
      const modToArray = mod.toString().split('');
      const length = modToArray.length - 1;
      const modToKorean = modToArray.reduce((acc, value, index) => {
        const valueToNumber = +value;
        if (!valueToNumber) return acc;
        const numberToKorean = koreanNumber[valueToNumber];
        return `${acc}${numberToKorean}${tenUnit[length - index]}`;
      }, '');

      answer = `${modToKorean}${tenThousandUnit.pop()}${answer}`;
      price = Math.floor(price / unit);
    }

    return answer.replace();
  } 

  useEffect(() => {
    sumPrice(data)
  } ,[])

  return (
    <div className="flex text-lg font-bold py-1 border-2 w-[100%] border-black">
      <div className="mx-5">금액 :</div>
      <div className="flex-grow text-left">{priceToKorean(totalPrice)}원 정</div>
      <div className="pr-2">₩ {priceComma(totalPrice)}</div>
    </div>
  )
}

export default Price;